import { Component, OnInit } from '@angular/core';
// Services
import { ElasticService } from './../../services/elastic';
// External
import { Club } from './../../models/club';

import * as lodash from 'lodash';
import { ApiService } from './../../services/api';
import { DatePipe } from '@angular/common';


@Component({
    templateUrl: './private.policy.component.html',
    selector: 'app-private-policy'
})
export class PrivatePolicyComponent implements OnInit {
    public imageLoader = true;
    public master = {
        text: ''
    };
    ngOnInit(): void {
        this.apiService.object("currentVersion/").then((result) => {
            if (result.pp) {
                this.master.text = result.pp
            }
            this.imageLoader = false
        })
    }


    constructor(private apiService: ApiService) {

    }
    public submit() {
        this.apiService.set("currentVersion/pp", this.master.text)
    }
}
